export default (theme => ({
  root: {},
  transitionGroup: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}));